exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2T6dC{display:inline-block;margin-right:5px}._2qrRd{text-align:center}", ""]);

// exports
exports.locals = {
	"displayIcon": "_2T6dC",
	"textCenter": "_2qrRd"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/ViewListing/SocialShare/SocialShare.css
// module id = 2580
// module chunks = 15